import angular from "angular"

FormularioEliminarUsuariosController.$inject = ["$scope", "$mdDialog", "saveCallback"]

function FormularioEliminarUsuariosController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.eliminar = function() {
    saveCallback()
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

angular
  .module("appModule")
  .controller("FormularioEliminarUsuariosController", FormularioEliminarUsuariosController)
